export default function InventoryFormRow(props) {
    return (
        <div className="form-group row justify-content-evenly">
            {props.children}
        </div>
    )
}